exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=\"radio\"] + label {\n  width: 10px !important;\n  height: 10px !important;\n  border-radius: 50%;\n  box-shadow: 2px 2px 0px rgba(51, 51, 51, 0.2);\n  transition: transform 0.2s ease;\n\n  margin-left: 20px;\n  margin-right: 10px;\n}\n.tag {\n  color: #ffffff !important;\n}\n.error {\n  background-color: lightpink !important;\n}\n", ""]);

// exports
